<footer class="lp-footer">
  <div class="d-flex gap-1">
    <span>{{ footerText }}</span>
    <span>|</span>
    <a class="c-pointer" (click)="showAIUsageDisclaimer = true">{{
      '::AIPowered' | abpLocalization
    }}</a>
  </div>
</footer>

<cai-ai-usage-disclaimer [(visible)]="showAIUsageDisclaimer"></cai-ai-usage-disclaimer>
